<template>
<!-- 订单管理 -->
<section>
  <!--工具条-->
  <div v-show="isOrder" @listenEdit="showOrder">
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao"></div>
      </div>
      <!-- 顶部搜索框 -->
      <el-collapse-transition>
      <div v-show="show3">
        <el-form :inline="true" :model="filters" class="findform">
          <el-form-item label="关键词语：" style="display:flex;width:20%">
            <el-input v-model="filters.keyword" placeholder="订单号/商品名称/手机号" maxlength="30" style="width:90%"/>
          </el-form-item>
          <el-form-item label="订单状态：" style="display:flex;width:20%">
            <el-select v-model="filters.orderStatusId" placeholder="请选择" ref="mySelect" style="width:90%">
              <el-option v-for="(item,index) in statusoptions" :key="index" :value="item.Id" :label="item.Name"/>
            </el-select>
          </el-form-item>
          <el-form-item label="所属品牌商：" style="display:flex;width:20%;">
            <el-cascader v-model="filters.pinpaishang" :options="optionsBrand" @change="handleChange"
              placeholder="请选择" filterable clearable style="width:90%"/>
          </el-form-item>
          <el-form-item label="下单时间：" style="display:flex;width:20%">
            <el-date-picker type="daterange" :title="value6" v-model="value6" :editable="iseditable" @change="changetime"
            value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width:90%;"/>
          </el-form-item>
          <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
        </el-form>
      </div>
      </el-collapse-transition>
    </div>
    <!--列表-->
    <div class="main_container">
      <section class="model_section">
        <p class="model_top_title">订单管理</p>
        <el-button type="danger" @click="showWatch()" v-if="menuAction.indexOf(45)>-1"
        style="float: right;margin: 5px 10px 0 0;">导出Excel</el-button>
      </section>
      <!-- table列表 -->
      <div class="table_container">
        <el-table :data="dataList" stripe border>
          <el-table-column label="订单编号" width="170" align="center">
            <template scope="scope">
              <span :title="scope.row.OrderNo" :label="scope.row.OrderNo">{{scope.row.OrderNo}}</span>
            </template>
          </el-table-column>
          <el-table-column label="订单金额" width="170" align="center">
            <template scope="scope">
              <span :title="scope.row.PaidPrice" :label="scope.row.PaidPrice">￥{{scope.row.PaidPrice}}</span>
            </template>
          </el-table-column>
          <el-table-column label="下单时间" width="170" align="center">
            <template scope="scope">
              <span :title="scope.row.PlaceOrderTime" :label="scope.row.PlaceOrderTime">{{scope.row.PlaceOrderTime}}</span>
            </template>
          </el-table-column>
          <el-table-column label="支付时间" width="170" align="center">
            <template scope="scope">
              <span :title="scope.row.PayTime" :label="scope.row.PayTime">{{scope.row.PayTime}}</span>
            </template>
          </el-table-column>
          <el-table-column label="所属品牌商" width="170" align="center">
            <template scope="scope">
              <span :title="scope.row.BbName" :label="scope.row.BbName">{{scope.row.BbName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="管家佣金" align="center">
            <template scope="scope">
              <span :title="scope.row.HkPrice" :label="scope.row.HkPrice">{{scope.row.HkPrice}}</span>
            </template>
          </el-table-column>
          <el-table-column label="共创佣金" align="center">
            <template scope="scope">
              <span :title="scope.row.CcePrice" :label="scope.row.CcePrice">{{scope.row.CcePrice}}</span>
            </template>
          </el-table-column>
          <el-table-column label="订单状态" align="center">
            <template scope="scope">
              <span :title="scope.row.OrderStatusName" :label="scope.row.OrderStatusName">{{scope.row.OrderStatusName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="100" align="center">
            <template scope="scope">
              <span @click="seeSelectOrderDetailById(scope.row.Id)" class="action_container">
                <i class="el-icon-view"></i> 查看
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
        :current-page="filters.pageIndex" :page-size="10" :total="total" style="margin:10px 0;float:right"/>
      </div>
    </div>
  </div>
  
  <!-- 订单管理 详情页查看-->
  <div class="main_container" v-if="isOrderWatch">
    <section class="model_section">
      <p class="model_top_title">订单管理查看</p>
      <div style="float: right;margin: 0 10px 0 0;">
        <el-button type="danger" @click="showEdit()" v-show="orderdetail.OrderStatusId == 2">发货</el-button>
        <el-button type="danger" @click="confirmCancle()" v-show="orderdetail.OrderStatusId < 3">取消订单</el-button>
        <el-button @click="showOrder()">返回</el-button>
      </div>
    </section>
    <!-- 订单信息 -->
    <div style="display:flex;flex-wrap: wrap;margin: 0 20px;">
      <span style="width:33%;display:flex" v-for="item in list" :key="item.index">
        <p style="white-space: nowrap;" class="watch_first">{{item.name}}</p>
        <p style="width:85%;word-wrap: break-word;">{{item.value}}</p>
      </span>
    </div>
    <!-- 表格 -->
    <div class="table_container">
    <el-table :data="detailList" stripe border style="margin: 10px 0 20px 0;">
      <el-table-column prop="GoodModelCode" label="商品型号"  align="center">
        <template scope="scope"><span>{{scope.row.GoodsCode}}</span></template>
      </el-table-column>
      <el-table-column prop="GoodModelCode" label="商品名称"  align="center">
        <template scope="scope"><span>{{scope.row.Title}}</span></template>
      </el-table-column>
      <el-table-column prop="Counts" label="颜色" align="center">
        <template scope="scope"><span>{{scope.row.ColorName}}</span></template>
      </el-table-column>
      <el-table-column prop="singleprice" label="单价"  align="center">
        <template scope="scope"><span>￥{{scope.row.TzrPrice}}</span></template>
      </el-table-column>
      <el-table-column prop="Counts" label="数量" align="center">
        <template scope="scope"><span>{{scope.row.Counts}}</span></template>
      </el-table-column>
      <el-table-column prop="PaidPrice" label="优惠券优惠金额" align="center">
        <template scope="scope"><span>￥{{scope.row.CouponPrice}}</span></template>
      </el-table-column>
      <el-table-column prop="CouponName" label="会员优惠金额" align="center">
        <template scope="scope"><span>￥{{scope.row.VipDiscountPrice}}</span></template>
      </el-table-column>
      <el-table-column prop="PaidPrice" label="实付" align="center">
        <template scope="scope"><span>￥{{scope.row.PaidPrice}}</span></template>
      </el-table-column>
      <el-table-column prop="Counts" label="状态" align="center">
        <template scope="scope"><span>{{scope.row.StatusName}}</span></template>
      </el-table-column>
    </el-table>
    </div>
  </div>
  
  <!-- 订单管理 发货-弹框页 -->
  <el-dialog title="发货" :center="true" :visible.sync="isOrderEdit" width="30%">
    <!--发货界面-->
    <el-form :model="form" label-width="100px" class="dialogForm">
      <el-form-item label="物流方式:">
        <el-select v-model="form.LogisticsModeId" placeholder="请选择" style="width:200px"
          @change="changeShow(form.LogisticsModeId)">
          <el-option v-for="item in wuliu" :key="item.Id" :label="item.Name" :value="item.Id"></el-option>
        </el-select>
      </el-form-item>
      <!-- 商家送货 -->
      <el-form-item class="pointer" style="" label="送货日期:" v-show="isBusiness">
        <el-date-picker type="date" v-model="form.DeliveryDate" :editable="iseditable" placeholder="选择日期"
          value-format="yyyy-MM-dd" :picker-options="pickerOptions1" style="width: 200px;cursor:pointer;"/>
        <img src="../../assets/img/aicon10_03.jpg" alt style="margin-left:10px" />
      </el-form-item>
      <!-- 第三方物流 -->
      <el-form-item label="物流公司:" prop="name" style="width:340px" v-show="isThird">
        <el-select v-model="form.LogisticsCompanyId" placeholder="请选择" style="width:200px">
          <el-option v-for="item in companys" :key="item.Id" :value="item.Id" :label="item.Name"/>
        </el-select>
        <!-- <el-input v-model="form.LogisticsCompanyId" class="inner_input_group" auto-complete="off" placeholder="请填写公司名称"></el-input> -->
      </el-form-item>
      <el-form-item label="物流单号:" prop="num" style="width:340px" v-show="isThird">
        <el-input v-model="form.LogisticsNumber" placeholder="请填写单号" maxlength="50"
          class="inner_input_group" auto-complete="off"/>
      </el-form-item>
    </el-form>
    <!-- 弹框按钮 确定/取消 -->
    <div style="padding-left:0;text-align:center">
      <el-button type="danger" @click="editSubmit()">确定</el-button>
      <el-button @click="isOrderEdit = false">取消</el-button>
    </div>
  </el-dialog>

</section>
</template>
<script>
import { SelectOrderList, SelectOrderDetailById, UpdateOrderLogisticsInfo,
  CancelOrderForBackground, SelectBBListByCondition, getkind } from "../../api/api";
// 订单状态(OrderStatusId): 1:待支付 2:代发货 3:待收货 4: 5:已取消 6:已评价 7:已完成
export default {
  data() {
    return {
      show3:false,
      value6: "",
      src: require("../../assets/img/aicon39.png"),
      isOrder: true, // 订单主页
      isOrderWatch: false, // 查看 订单详情页
      isOrderEdit: false, // 发货界面弹框
      dataList: [], // 查询列表
      optionsBrand: [],
      filters: {
        keyword: "",
        orderStatusId: 0,
        pinpaishang: '',
        beginTime: "", // 开始时间
        endTime: "", // 结束时间
        cityId: "",
        bbId: "",
        pageIndex: 1,
        pageSize: 10,
      },
      statusoptions: [], // 订单状态
      iseditable: false,
      total: 1,
      page: 1,
      option: [
        {
          id: 1,
          name: "商家送货上门"
        },
        {
          id: 2,
          name: "第三方物流"
        }
      ],
      // 发货弹框数据
      form: {
        LogisticsModeId: "", //物流方式
        LogisticsCompanyId: "", //物流公司Id
        LogisticsNumber: "", //物流单号
        DeliveryDate: "", //送货日期
        OrderDetailId: "",
        OperatorId: this.$cookie.get("OperatorId")
      },
      cancleData: {
        remark: "",
        orderDetailId: "",
        operId: this.$cookie.get("OperatorId")
      },
      isBusiness: false, // 是否为商家送货
      isThird: false, // 是否为第三方送货
      list: [], // 详情基本信息
      detailList: [], // 详情列表
      wuliu: [], // 物流
      // 送货日期
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      companys: [],
      orderdetail: [],
      orderdetailId: ""
    };
  },
  methods: {
    //查询列表
    getorder() {
      let that = this;
      that.dataList = [];
      var addParams = {
        userId: localStorage.Id,
        keyword: that.filters.keyword,
        orderStatusId: that.filters.orderStatusId,
        beginTime: that.filters.beginTime, // 开始时间
        endTime: that.filters.endTime, // 结束时间
        cityId: that.filters.cityId,
        bbId: that.filters.bbId,
        pageIndex: that.filters.pageIndex,
        pageSize: 10,
      };
      SelectOrderList(addParams).then(data => {
        this.dataList = data.ResultObj;
        this.total = data.RowsCount;
      }).catch(err => {
        this.dataList = [];
      });
    },
    // 重置
    fnReset() {
      this.filters.keyword = '';
      this.filters.orderStatusId = 0;
      this.filters.pinpaishang = '';
      this.filters.cityId = '',
      this.filters.bbId = '',
      this.value6 = '';
      this.filters.beginTime = '';
      this.filters.endTime = '';
      // this.filters.pageIndex = 1;
      // this.getorder();
    },
    //查询
    onSubmit() {
      this.filters.pageIndex = 1;
      this.getorder();
    },
    // 下单时间
    changetime() {
         if(this.value6+""=="null"){
           this.value6 = ["",""]
      }
      this.filters.beginTime = this.value6[0];
      this.filters.endTime = this.value6[1];
    },
    // 查询订单详情
    getOrderDetail(id){
      var addParams = {
        orderId: id
      };
      SelectOrderDetailById(addParams).then(data => {
        data = data.ResultObj;
        this.orderdetail = data;
        let newdetailList = data.DetailList;
        for (var obj of newdetailList) {
          if (obj.Counts != 0) {
            obj.singleprice = Number(obj.OriginalPrice) / Number(obj.Counts);
            obj.singleprice = obj.singleprice.toFixed("2");
          } else {
            obj.singleprice = 0;
          }
        }
        this.detailList = newdetailList;
        this.list = [
          {
            index: 1,
            name: "订单编号：",
            value: data.OrderNo
          },
          {
            index: 2,
            name: "下单时间：",
            value: data.PlaceOrderTime
          },
          {
            index: 3,
            name: "订单状态：",
            value: data.StatusName
          },
          {
            index: 4,
            name: "下 单 人 ：",
            value: data.UserName
          },
          {
            index: 5,
            name: "收 件 人 ：",
            value: data.ReceiverName
          },
          {
            index: 6,
            name: "联系方式：",
            value: data.ReceiverPhone
          },
          {
            index: 7,
            name: "收货地址：",
            value: data.Address
          },
          {
            index: 8,
            name: "支付方式：",
            value: data.PayTypeName
          },
          {
            index: 9,
            name: "商品合计：",
            value: "￥"+data.OriginalPrice
          },
          {
            index: 10,
            name: "优　　惠：",
            value: "￥"+data.FavorablePrice
          },
          {
            index: 11,
            name: "实　　付：",
            value: "￥"+data.PaidPrice
          },{
              index: 12,
            name: "订单备注：",
            value: data.Remark
          },{
            index: 13,
            name: "送货时间：",
            value: data.DeliveryDate
          }
        ];
      })
    },
    //查看订单
    seeSelectOrderDetailById(id) {
      this.orderdetailId = id;
      this.isOrder = false; // 订单主页
      this.isOrderWatch = true; // 详情页查看
      this.getOrderDetail(id); // 调用查询订单接口
    },
    // 取消订单
    confirmCancle() {
      this.$swal({
        type:'warning',
        text: '取消订单',
        showCancelButton:true,
        cancelButtonText: '取消',
        confirmButtonText: '确定',
      }).then(res => {
        if (res.value) {
          CancelOrderForBackground({
            orderId: this.orderdetailId,
            operatorId: localStorage.Id
          }).then(r => {
            if(r.ResultCode == 1){
              this.$swal({
                text: "操作成功",
                type: "success"
              });
            }
            this.getOrderDetail(this.orderdetailId); // 调用查询订单接口
            this.getorder(); // 刷新订单列表
          });
        }
      })
    },
    handleChange(val) {
      this.filters.cityId = val[0];
      this.filters.bbId = val[1];
    },
    // 显示主页
    showOrder() {
      this.isOrder = true; // 订单主页
      this.isOrderWatch = false; // 详情页查看
      this.isOrderEdit = false; // 发货弹框
    },
    // 显示发货弹框
    showEdit() {
      this.isOrderEdit = true; // 发货弹框
      this.isBusiness = false;
      this.isThird = false;
      this.form = {
        LogisticsModeId: "", //物流方式
        LogisticsCompanyId: "", //物流公司Id
        LogisticsNumber: "", //物流单号
        DeliveryDate: "", //送货日期
        OrderDetailId: ""
      }
    },
    // 确认发货
    editSubmit() {
      let params = JSON.parse(JSON.stringify(this.form));
          params.LogisticsModeId == 1 ? delete params.DeliveryDate : (delete params.LogisticsCompanyId, delete params.LogisticsNumber);
      if (params.LogisticsModeId == "") {
        this.$swal({
          text: "请选择物流方式",
          type: "warning"
        });
        return false;
      } else {
        if (params.LogisticsModeId == 1) {
          if (
            params.LogisticsCompanyId == "" ||
            params.LogisticsCompanyId == null
          ) {
            this.$swal({
              text: "请选择物流公司",
              type: "warning"
            });
            return false;
          } else if (
            params.LogisticsNumber == "" ||
            params.LogisticsNumber == null
          ) {
            this.$swal({
              text: "请填写物流编号",
              type: "warning"
            });
            return false;
          }
        } else {
          if (params.DeliveryDate == "" || params.DeliveryDate == null) {
            this.$swal({
              text: "请先择派送日期",
              type: "warning"
            });
            return false;
          }
        }
      }
      var addParams = {
        orderId: this.orderdetailId, // 订单id
        operatorId: localStorage.Id, // 当前操作人id
        logisticsModeId: params.LogisticsModeId,
        logisticsCompanyId: params.LogisticsCompanyId,
        logisticsNumber: params.LogisticsNumber, // 物流单号
        deliveryDate: params.DeliveryDate,
      };
      UpdateOrderLogisticsInfo(addParams).then(r => {
        if (r.ResultCode == 1) {
          this.$swal({
            text: "编辑成功",
            type: "success"
          });
          this.isOrderEdit = false; // 发货成功后弹框消失
          this.getOrderDetail(this.orderdetailId); // 调用查询订单接口
          this.getorder(); // 刷新订单列表
        }
      });
    },
    //获取城市下的品牌商
    getBrandByCityId() {
      var obj = {
        userId: localStorage.Id
      };
      SelectBBListByCondition(obj).then(data => {
        var obj2 = {};
        var obj1 = {};
        this.optionsBrand.unshift({
          value:0,
          label:"全部"
        })
        data.ResultObj.map(item => {
          obj2 = item;
          obj2["value"] = item["CityId"];
          obj2["label"] = item["CityName"];
          obj2["children"] = item["BbModel"];
          obj2.children.map(item => {
            obj1 = item;
            obj1["value"] = item["Id"];
            obj1["label"] = item["Name"];
          });
           obj2.children.unshift({
              value:0,
             label:"全部"
           })
          this.optionsBrand.push(obj2);
        });
      });
    },
    //获取订单状态
    getorderstatus() {
      let that = this;
      var addParams = {
        tableName: "tBDOrderStatus",
        keyWord: "",
        parentId: ""
      };
      getkind(addParams).then(data => {
        let newdata = data.ResultObj;
        let obj = {
          Id: 0,
          Name: "全部"
        };
        newdata.unshift(obj);
        let chargeback = {
          Id: 8,
          Name: "已退单"
        };
        newdata.push(chargeback);
        that.statusoptions = newdata;
      });
    },
    //获取物流方式
    getwuliu() {
      let that = this;
      var addParams = {
        tableName: "tBDLogisticsMode",
        keyWord: "",
        parentId: ""
      };
      getkind(addParams).then(data => {
        that.wuliu = data.ResultObj;
      });
    },
    // 获取物流公司
    getWuliuCompany() {
      let that = this;
      var addParams = {
        tableName: "tBDLogisticsCompany",
        keyWord: "",
        parentId: "-1"
      };
      getkind(addParams).then(data => {
        that.companys = data.ResultObj;
      });
    },
    // 导出
    showWatch() {
      let that = this;
      var addParams = [
        {
          name: "userId",
          value: localStorage.Id
        },
        {
          name: "keyword",
          value: that.filters.keyword
        },
        {
          name: "orderStatusId",
          value: that.filters.orderStatusId
        },
        {
          name: "beginTime",
          value: that.filters.beginTime
        },
        {
          name: "endTime",
          value: that.filters.endTime
        },
        {
          name: "cityId",
          value: that.filters.cityId
        },
        {
          name: "bbId",
          value: that.filters.bbId
        }
      ];
      var url = "/order/ordermanage/ExportToExcel";
      this.downLoad(url, addParams);
    },
    // 分页
    handleCurrentChange(val) {
      this.filters.pageIndex = val;
      this.getorder();
    },
    // 物流方式
    changeShow(option) {
      if (option == 2) {
        this.form.LogisticsCompanyId = "";
        this.form.LogisticsNumber = "";
        this.isBusiness = true;
        this.isThird = false;
      } else {
        (this.isBusiness = false), (this.isThird = true);
      }
    }
  },
  created() {
    let that = this;
    //获取订单状态
    this.getorderstatus();
    // 获取所属品牌商
    this.getBrandByCityId();
    //获取物流方式
    this.getwuliu();
    // 获取物流公司
    this.getWuliuCompany();
    setTimeout(function() {
      that.getorder();
    }, 200);
  },
  mounted() {},
  props: ["menuAction"],
  watch: {
    menuAction: function(val) {
      this.menuAction = val;
    }
  }
};
</script>
<style scoped>
/* 表格操作 */
.action_container {
  color: #677c9d;
  cursor: pointer;
}
.dialogForm {
  width: 100%;
  margin: 0 auto;
  padding-bottom: 10px;
}
.watch_tab {
  padding-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// order.vue?25e7fc03